import { Component, Fragment } from 'react';

import { enableMonitor, TAMProjectIDClient } from '../../config/tam';
import { NEW_CDN_DOMAIN } from '../../constants';
import Error from '../Error';

function TAMsdk() {
  const initCode = `
    function init(){
      if (window.Aegis) {
        window.globalAegis = new window.Aegis({
          id: '${TAMProjectIDClient}', // 项目key
          reportApiSpeed: true, // 接口测速
          reportAssetSpeed: true, // 静态资源测速
          api: {
            apiDetail: true, // 接口异常，上报参数和回包
          },
          hostUrl: 'https://rumt-sg.com',
          beforeReport(log) {
            try {
              if (log.msg.indexOf('ResizeObserver loop limit exceeded') > -1) {
                // 忽略该错误，参考：https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
                return false;
              }
              if (log.msg.indexOf('Script error.') > -1) {
                // 忽略Script error . 错误，参考：https://cloud.tencent.com/document/product/1464/58608
                // 该问题是加载 cdn 上 script 由于加载异常出现的安全提醒问题，加入cdn域名容灾后，这类错误是可预见出现
                return false;
              }
            } catch (err) {}
          },
        })
      }else{
        setTimeout(function(){
          init();
        },300)
      }
    }
    init();
  `;

  return (
    <>
      {enableMonitor && TAMProjectIDClient ? (
        <Fragment>
          <script async src={`//${NEW_CDN_DOMAIN}/qcloud/intl/statics/js/aegis.1_38_67_min.js`}></script>
          <script
            dangerouslySetInnerHTML={{
              __html: initCode,
            }}
          />
        </Fragment>
      ) : null}
    </>
  );
}

/**
 * 捕获React错误
 */
class TAMMonitor extends Component {
  state = {
    hasError: false,
    error: null,
    componentStack: null,
  };

  componentDidCatch(error, { componentStack }) {
    this.setState({
      hasError: true,
      error,
      componentStack,
    });
    // 上报错误
    if (window && window.globalAegis) {
      window.globalAegis.error({
        error,
        componentStack,
      });
    }
  }

  render() {
    const { hasError, error, componentStack } = this.state;
    const { fallback, children } = this.props;

    if (hasError) {
      if (fallback) {
        if (typeof fallback === 'string') {
          return fallback;
        }

        // todo 不好判断fallback参数是否是组件，待优化
        const Fallback = fallback;
        return <Fallback error={error} componentStack={componentStack} />;
      }
      return <Error />;
    }
    return children;
  }
}

/**
 * 绑定单个组件
 * @param Component
 * @param fallback
 * @returns {JSX.Element}
 */
function withTAMMonitor(Component, fallback) {
  return function MonitorComponent(props) {
    return (
      <Fragment>
        <TAMMonitor fallback={fallback}>
          <Component {...props} />
        </TAMMonitor>
      </Fragment>
    );
  };
}

export { TAMMonitor, TAMsdk, withTAMMonitor };
